import { render, staticRenderFns } from "./MobileIphone.vue?vue&type=template&id=13866659&scoped=true&"
import script from "./MobileIphone.vue?vue&type=script&lang=js&"
export * from "./MobileIphone.vue?vue&type=script&lang=js&"
import style0 from "./MobileIphone.vue?vue&type=style&index=0&id=13866659&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13866659",
  null
  
)

export default component.exports